import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    DeleteDriveFiles,
    DeleteDriveFolderIrreversibly,
    MoveDriveFoldersToRecycle,
    MoveDriveFilesToRecycle,

    setDriveAction,
    isRecycleOpened,
    clearDriveSelection,
    reloadDriveLists,
} from "client/store"
import {
    Button,
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    SpinnerIcon,
} from "client/components"


export const Remove = () => {
    const drivePath = useSelector((state: StoreType) => state.drive.drivePath)

    const folderActive = useSelector((state: StoreType) => state.drive.folder.active)
    const foldersSelected = useSelector((state: StoreType) => state.drive.folder.selected)

    const fileActive = useSelector((state: StoreType) => state.drive.file.active)
    const filesSelected = useSelector((state: StoreType) => state.drive.file.selected)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [moveState, setMoveState] = useState<StateType>(IDLE)
    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const files = fileActive ? [fileActive] : filesSelected
    const folders = folderActive ? [folderActive] : foldersSelected

    const onCancel = () => {
        dispatch(setDriveAction(null))
    }

    const onConfirmDelete = () => {
        setDeleteState(PENDING)

        const promiseArray: Promise<any>[] = [
            DeleteDriveFiles(files),
        ]
        folders.forEach((folder) => {
            promiseArray.push(
                DeleteDriveFolderIrreversibly(folder, true, userData, lang),
            )
        })

        Promise.all(promiseArray).then(() => {
            setDeleteState(IDLE)

            clearDriveSelection(dispatch)
            reloadDriveLists(dispatch)
        })
    }

    const onConfirmMove = () => {
        setMoveState(PENDING)

        Promise.all([
            MoveDriveFoldersToRecycle(folders),
            MoveDriveFilesToRecycle(files),
        ]).then(() => {
            setMoveState(IDLE)

            clearDriveSelection(dispatch)
            reloadDriveLists(dispatch)
        })
    }

    const recycleOpened = isRecycleOpened(drivePath)

    return (
        <ConfirmWrapper show onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{lang.confirmDeletionTitle}</ConfirmTitle>
                <ConfirmDescription>
                    {recycleOpened ? lang.confirmDeletionRecycleDescription : lang.confirmDeletionDescription}
                </ConfirmDescription>
                {
                    !recycleOpened && (
                        <ConfirmBottom>
                            <Button variant="success" row disabled={deleteState === PENDING} onClick={onConfirmMove}>
                                {moveState === PENDING ? <SpinnerIcon /> : lang.moveToRecycleBin}
                            </Button>
                            <Button variant="danger" row disabled={moveState === PENDING} onClick={onConfirmDelete}>
                                {deleteState === PENDING ? <SpinnerIcon /> : lang.deleteIrreversibly}
                            </Button>
                            <Button row onClick={onCancel}>
                                {lang.cancel}
                            </Button>
                        </ConfirmBottom>
                    )
                }
                {
                    recycleOpened && (
                        <ConfirmBottom>
                            <Button variant="success" row onClick={onConfirmDelete}>
                                {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                            </Button>
                            <Button row onClick={onCancel}>
                                {lang.cancel}
                            </Button>
                        </ConfirmBottom>
                    )
                }
            </Confirm>
        </ConfirmWrapper>
    )
}
export default Remove
